<template>
  <a-spin :spinning="confirmLoading">
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="等级名称">
        <a-input
          size="large"
          :max-length="100"
          style="width: 500px"
          placeholder="请输入等级名称,不超过100个字"
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入等级名称,不超过100个字',
                },
              ],
            },
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="会员权益">
        <a-tree-select
          size="large"
          style="width: 500px"
          ref="ctGbRelations"
          :tree-data="relationsTree"
          @change="onRelationsChange"
          tree-checkable
          placeholder="请选择会员权益"
          v-decorator="[
            'ctGbRelations',
            {
              rules: [
                {
                  required: true,
                  message: '请选择会员权益',
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="权限管理">
        <a-tree-select
          size="large"
          style="width: 500px"
          ref="cmCtPermissions"
          :tree-data="columnChannel"
          @change="onChange"
          tree-checkable
          placeholder="请选择栏目"
          v-decorator="[
            'cmCtPermissions',
            {
              rules: [
                {
                  required: true,
                  message: '请选择栏目',
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="卡种">
        <member-level-card
          size="large"
          style="width: 500px"
          v-decorator="[
            'ctMmGrades',
            {
              rules: [
                {
                  required: true,
                  message: '请填写卡种',
                },
              ],
            },
          ]"
        ></member-level-card>
      </a-form-item>
      <a-form-item label="icon">
        <UploadImage :imgUrl="iconUrl" @handleFileList="handleImageList" />
      </a-form-item>
      <a-form-item label="排序">
        <a-input-number
          v-decorator="[
            'idx',
            {
              rules: [
                {
                  required: true,
                  message: '请填写排序',
                },
              ],
            },
          ]"
        ></a-input-number>
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import { jsonAction, getAction } from '@/api/manage';
import MemberLevelCard from './MemberLevelCard';
import { findTreeNodeArray } from '@/utils/common';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'MemberLevelForm',
  components: {
    MemberLevelCard,
    UploadImage
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    columnChannel: {
      type: Array,
      default: [],
    },
    relationsTree: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      model: {
        idx: 1,
      },
      iconUrl: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this), //form对象
      columnList: [],
      relationsList: [],
      editData: {},
      url: {
        add: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmGroup/add',
        edit: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmGroup/edit',
        queryById:
          process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmGroup/queryById',
      },
      init: {
        columnList: [],
        relationsList: [],
      },imgFile: {}
    };
  },
  computed: {
    formDisabled() {
      return this.disabled;
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
  },
  methods: {
    handleImageList(file) {
      this.imgFile = file;
      this.iconUrl = file.fileUrl;
    },
    add() {
      this.$nextTick(() => {
        this.form.setFieldsValue(this.modelDefault);
      });
    },
    edit(record) {
      this.id = record.id;
      let params = {
        id: record.id,
      };
      getAction(this.url.queryById, params).then((res) => {
        if (res.success) {
          let arr = [];
          if (
            res.result.cmCtPermissions &&
            res.result.cmCtPermissions.length > 0
          ) {
            res.result.cmCtPermissions.forEach((item) => {
              arr.push(this.getChannelData(item.columnCode));
            });
          }
          this.init.columnList = Object.assign([], arr);
          this.columnList = arr;
          //ctGbRelations
          let rltArr = [];
          if (res.result.ctGbRelations && res.result.ctGbRelations.length > 0) {
            res.result.ctGbRelations.forEach((item) => {
              rltArr.push(item.benefitsId);
            });
          }
          this.init.relationsList = Object.assign([], arr);
          this.relationsList = rltArr;
          this.iconUrl = res.result.previewUrl;
          this.imgFile.fileUrl = res.result.previewUrl;
          this.imgFile.fileName = res.result.icon;
          this.$nextTick(() => {
            this.model = res.result;
            let data = {
              name: this.model.name,
              ctGbRelations: rltArr,
              cmCtPermissions: arr,
              ctMmGrades: this.model.ctMmGrades,
              idx: this.model.idx,
            };
            this.form.setFieldsValue(data);
          });
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //权益
    onRelationsChange(value, label, val) {
      this.relationsList = value;
    },
    //栏目
    onChange(value, label, val) {
      let newList = this.init.columnList.concat(value);
      newList = Array.from(new Set(newList));
      this.$nextTick(() => {
        this.form.setFieldsValue({
          cmCtPermissions: newList,
        });
      });
      this.columnList = newList;
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        this.model = {};
        let formData = Object.assign(this.model, values);
        formData.ctGbRelations = this.handleRelationsData(); //this.relationsList;
        formData.cmCtPermissions = this.handleChannelData(); //this.columnList;
        formData.icon = this.imgFile.fileName;
        if (!err) {
          let httpurl = '';
          let method = 'post';
          if (!this.id) {
            httpurl += this.url.add;
          } else {
            formData.id = this.id;
            httpurl += this.url.edit;
          }
          jsonAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    getChannelData(code) {
      let arr = findTreeNodeArray('children', this.columnChannel, (e) => {
        return code == e.code;
      });
      if (arr.length > 0) {
        return arr[0].value;
      }
      return '';
    },
    handleChannelData() {
      let arr = findTreeNodeArray('children', this.columnChannel, (e) => {
        return this.columnList.filter((item) => item == e.id).length > 0;
      });
      console.log('arr++++++', arr);
      let list = [];
      arr.forEach((item) => {
        let obj = {
          columnCode: item.code,
          channelCode: item.channelCode,
        };
        list.push(obj);
      });
      return list;
    },
    handleRelationsData() {
      let arr = findTreeNodeArray('children', this.relationsTree, (e) => {
        return this.relationsList.filter((item) => item == e.value).length > 0;
      });
      console.log('arr++++++', arr);
      let list = [];
      arr.forEach((item) => {
        let obj = {
          benefitsId: item.value,
          benefitsName: item.title,
        };
        list.push(obj);
      });
      return list;
    },
  },
};
</script>